import { SVGProps } from 'react'

export const RoundedPatternIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M46.5 12h-3a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5m-33 12h3a1.5 1.5 0 0 0 1.5-1.5V18h4.5a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5h-9a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5M36 37.5a1.5 1.5 0 0 0-1.5-1.5H30v-4.5a1.5 1.5 0 0 0-1.5-1.5H24v-4.5a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0-1.5 1.5V30h-4.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V42h4.5a1.5 1.5 0 0 0 1.5-1.5zM24 42h-6v-6h6z"
			fill="currentColor"
		/>
		<path
			d="M46.5 24H36V13.5a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0-1.5 1.5V18h-4.5a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5H30v4.5a1.5 1.5 0 0 0 1.5 1.5H36v4.5a1.5 1.5 0 0 0 1.5 1.5H42v6h-4.5a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-21a1.5 1.5 0 0 0-1.5-1.5"
			fill="currentColor"
		/>
	</svg>
)

export const DotsPatternIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M21 30a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path d="M21 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6" fill="currentColor" />
		<path
			d="M15 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path d="M21 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6" fill="currentColor" />
		<path
			d="M15 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-12 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12-18a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path
			d="M33 24a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path
			d="M39 30a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6-12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path
			d="M45 30a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6M15 24a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path
			d="M21 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6m12 24a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			fill="currentColor"
		/>
		<path d="M39 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6" fill="currentColor" />
	</svg>
)

export const ClassyPatternIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36 24V12h-4.5a1.5 1.5 0 0 0-1.5 1.5V18h-4.5a1.5 1.5 0 0 0-1.5 1.5V24h6v6h6v6h6v6h-4.5a1.5 1.5 0 0 0-1.5 1.5V48h10.5a1.5 1.5 0 0 0 1.5-1.5V24z"
			fill="currentColor"
		/>
		<path
			d="M43.5 12a1.5 1.5 0 0 0-1.5 1.5V18h4.5a1.5 1.5 0 0 0 1.5-1.5V12zM18 22.5V18h4.5a1.5 1.5 0 0 0 1.5-1.5V12H13.5a1.5 1.5 0 0 0-1.5 1.5V24h4.5a1.5 1.5 0 0 0 1.5-1.5M30 30h-6v-6h-4.5a1.5 1.5 0 0 0-1.5 1.5V30h-4.5a1.5 1.5 0 0 0-1.5 1.5V48h16.5a1.5 1.5 0 0 0 1.5-1.5V42h4.5a1.5 1.5 0 0 0 1.5-1.5V36h-6zm-6 12h-6v-6h6z"
			fill="currentColor"
		/>
	</svg>
)

export const ClassyRoundedPatternIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M35.933 24C36 23.753 36 12 36 12h-1.5a4.5 4.5 0 0 0-4.5 4.5V18h-1.5a4.5 4.5 0 0 0-4.5 4.5V24h6v6h6v6h6v6h-1.5a4.5 4.5 0 0 0-4.5 4.5V48h7.5a4.5 4.5 0 0 0 4.5-4.5V24z"
			fill="currentColor"
		/>
		<path
			d="M46.5 12a4.5 4.5 0 0 0-4.5 4.5V18h1.5a4.5 4.5 0 0 0 4.5-4.5V12zM18 19.5V18h1.5a4.5 4.5 0 0 0 4.5-4.5V12h-7.5a4.5 4.5 0 0 0-4.5 4.5V24h1.5a4.5 4.5 0 0 0 4.5-4.5M30 30h-6v-6h-1.5a4.5 4.5 0 0 0-4.5 4.5V30h-1.5a4.5 4.5 0 0 0-4.5 4.5V48h13.5a4.5 4.5 0 0 0 4.5-4.5V42h1.5a4.5 4.5 0 0 0 4.5-4.5V36h-6zM18 42v-6h6v6z"
			fill="currentColor"
		/>
	</svg>
)

export const SquarePatternIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M36 24V12h-6v6h-6v6h6v6h6v6h6v6h-6v6h12V24z" fill="currentColor" />
		<path
			d="M48 12h-6v6h6zm-24 6v-6H12v12h6v-6zm6 18v-6h-6v-6h-6v6h-6v18h18v-6h6v-6zm-6 6h-6v-6h6z"
			fill="currentColor"
		/>
	</svg>
)

export const ExtraRoundedPatternIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={60}
		height={60}
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M45.75 12h-1.5A2.25 2.25 0 0 0 42 14.25v1.5A2.25 2.25 0 0 0 44.25 18h1.5A2.25 2.25 0 0 0 48 15.75v-1.5A2.25 2.25 0 0 0 45.75 12M45 24h-9v-9a3 3 0 0 0-6 0v3h-3a3 3 0 0 0 0 6h3v3a3 3 0 0 0 3 3h3v3a3 3 0 0 0 3 3h3v6h-3a3 3 0 0 0 0 6h6a3 3 0 0 0 3-3V27a3 3 0 0 0-3-3m-30 0a3 3 0 0 0 3-3v-3h3a3 3 0 0 0 0-6h-6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3"
			fill="currentColor"
		/>
		<path
			d="M33 36h-3v-3a3 3 0 0 0-3-3h-3v-3a3 3 0 0 0-6 0v3h-3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-3h3a3 3 0 0 0 0-6m-9 6h-6v-6h6z"
			fill="currentColor"
		/>
	</svg>
)
